import useProtonKeepAlive from './useProtonKeepAlive';

export default function useIncomingKeepAlive() {
    useProtonKeepAlive();
}
